const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "";
const API_ORIGIN_FOR_WS =
	import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_APP_API_URL || "";

// Normalize WS base origin.
// Priority: VITE_WS_BASE_URL (full origin like ws(s)://host[:port])
// Fallback: derive from VITE_API_BASE_URL by switching protocol to ws/wss
// Final fallback: current window.location origin
const _envWs = import.meta.env.VITE_WS_BASE_URL || '';
function deriveWsBase() {
	if (_envWs && typeof _envWs === 'string' && _envWs.length > 0) return _envWs.replace(/\/$/, '');
	if (API_ORIGIN_FOR_WS) {
		try {
			const url = new URL(API_ORIGIN_FOR_WS);
			const proto = url.protocol === 'https:' ? 'wss:' : 'ws:';
			return `${proto}//${url.host}`;
		} catch {
			// ignore and fallback
		}
	}
	if (typeof window !== 'undefined') {
		const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
		return `${proto}//${window.location.host}`;
	}
	return '';
}

const WS_BASE_URL = deriveWsBase();

export { API_BASE_URL, WS_BASE_URL };
export default API_BASE_URL;
